import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Col } from 'react-bootstrap';
import Widget from '../Widget';
import { getProjectIssuesCount } from '../../../../../../modules/jira';
import { fetchUserStoriesCovered } from '../../../../../../modules/dashboard';

const TestRequirementCoverage = ({
  projectId,
  selectedJiraProject,
  isJiraIntegrated,
}) => {
  const jiraProjectId = selectedJiraProject?.linked_project_id;

  const { data: totalStories, isLoading: isLoadingTotal } = useQuery({
    queryKey: [`totalStories`, projectId, jiraProjectId],
    queryFn: () =>
      getProjectIssuesCount(
        `project = ${jiraProjectId} AND issuetype = 'Story'`,
        projectId,
        jiraProjectId,
      ),
    enabled: isJiraIntegrated && !!jiraProjectId,
  });

  const { data: coveredStories, isLoading: isLoadingCovered } = useQuery({
    queryKey: [`coveredStories`, projectId, jiraProjectId],
    queryFn: () => fetchUserStoriesCovered(projectId, jiraProjectId),
    enabled: isJiraIntegrated && !!jiraProjectId,
  });

  const percentageCovered =
    totalStories && coveredStories && totalStories.count > 0
      ? Math.round((coveredStories.count / totalStories.count) * 100)
      : 0;

  return (
    <>
      <Col className="test-cycle-widget">
        <Widget
          title="Total Stories in Jira"
          body={totalStories?.count}
          showWarning={!isJiraIntegrated}
          loading={isLoadingTotal}
          link={totalStories?.jira_url}
        />
      </Col>
      <Col className="test-cycle-widget">
        <Widget
          title="Stories Covered"
          body={coveredStories?.count}
          showWarning={!isJiraIntegrated}
          loading={isLoadingCovered}
          link={coveredStories?.jira_url}
        />
      </Col>
      <Col className="test-cycle-widget">
        <Widget
          title="Test Coverage"
          body={percentageCovered}
          percentage
          showWarning={!isJiraIntegrated}
          loading={isLoadingTotal || isLoadingCovered}
        />
      </Col>
    </>
  );
};

export default TestRequirementCoverage;
